import { RouteRecordRaw, RouteLocationNormalizedLoadedGeneric } from 'vue-router';

export const miniProgramRouters: RouteRecordRaw[] = [
  {
    path: '/product/list',
    name: 'ProductList',
    meta: {
      title: '产品中心',
      requiresAuth: false,
      keepAlive: true,
    },
    component: () => import('@/pages/miniProgram/product/list.vue'),
  },
  {
    path: '/product/details/:id?',
    name: 'ProductDetails',
    meta: {
      title: '产品详情',
      requiresAuth: false,
      disabledNavBar: true,
    },
    component: () => import('@/pages/miniProgram/product/details.vue'),
  },
];
